module.exports = __webpack_public_path__ + "static/media/cz.887bde53.svg";